<template>
  <app-layout>
    <template v-slot:header>
      <AppHead title="My Products" />
      <div class="d-flex align-items-center py-2">
        <h2 class="mr-3">My Products</h2>
        <jet-button class="btn-short" :goesTo="route('mtd.products.create')" icon="fas fa-plus">Create Product</jet-button>
        <flash-messages />
      </div>
    </template>
        
    <template v-slot:default>
      <div class="row py-3">
        <div class="col-12">
          <DataTable :value="products" v-model:expandedRows="expandedRows"
            responsiveLayout="stack"
            breakpoint="992px"
            class="p-datatable-sm" tableClass="border-left border-right border-bottom" 
            :rowClass="() => { return 'table-row' }"
            stripedRows>
            <Column class="width-50 d-flex d-lg-table-cell justify-content-start mb-3 mb-lg-0" field="active" header="Active">
              <template #body="slotProps">
                <InputSwitch class="ml-3" v-model="slotProps.data.active" @change.stop="active(slotProps.data)" />
              </template>
            </Column>
            <Column class="width-50 d-flex d-lg-table-cell justify-content-end mb-3 mb-lg-0">
              <template #body="slotProps">
                <div class="flex-center">
                  <img v-if="slotProps.data.thumb" class="block w-5 h-5 rounded-full my-products-img" :src="slotProps.data.thumb" />
                </div>
              </template>
            </Column>
            <Column class="width-50 hide-title-mobile mb-3 mb-lg-0" field="image_url" header="Name">
              <template #body="slotProps">
                <inertia-link :href="route('mtd.products.edit', slotProps.data.id)">
                  {{ slotProps.data.name }}
                </inertia-link>
                <icon v-if="slotProps.data.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
              </template>
            </Column>
            <Column class="width-50 hide-title-mobile d-flex d-lg-table-cell justify-content-end mb-3 mb-lg-0" field="sku" header="SKU"></Column>
            <Column field="price_msrp" header="MSRP">
              <template #body="slotProps">
                {{ formatDollars(slotProps.data.price_msrp) }}
              </template>
            </Column>
            <Column field="inventory_count" header="Store Price">
              <template #body="slotProps">
                <AmountInput id="user_price" v-model="slotProps.data.user_price" bottom-margin="mb-0" class="input-group-sm store-price" @input="updatePrice($event, products[slotProps.index])" />
              </template>
            </Column>
            <Column field="" header="On Truck #">
              <template #body="slotProps">
                <input id="inventory_number"   type="number" step="1" class="form-control form-control-sm custom-form-inline" size="3" v-model="slotProps.data.inventory_count" @input="updateInventory($event, products[slotProps.index])" />
              </template>
            </Column>
            <Column field="id" class="button-container" header="">
              <template #body="slotProps">
                <jet-button class="mr-2 btn-sm" icon="fas fa-eye" :goesTo="route('mtd.products.edit', slotProps.data.id)"></jet-button>
                <jet-button class="mr-2 btn-sm" icon="fas fa-edit" :goesTo="route('mtd.products.edit', slotProps.data.id)" tabindex="-1"></jet-button>
                <jet-button icon="fas fa-trash" class="btn-sm" @click.stop.prevent="deleteProduct(slotProps.data)"></jet-button>
              </template>
            </Column>
          </DataTable>
          <jet-button class="mt-3" :class="{ 'opacity-25': processing }" btnStyle="dark" icon="fas fa-save" :disabled="processing" @click="save">
              Save Changes
          </jet-button>
        </div>
      </div>
    </template>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import Icon from '@/Shared/Icon'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import JetButton from '@/Jetstream/Button'
import InputSwitch from 'primevue/inputswitch'
import FlashMessages from '@/Shared/FlashMessages'
import AmountInput from '@/Shared/AmountInput'

export default {
  metaInfo: { title: 'Products' },
  components: {
    Icon,
    SearchFilter,
    AppLayout,
    JetButton,
    InputSwitch,
    FlashMessages,
    AmountInput
  },
  props: {
    products: Array,
    filters: Object,
  },
  data() {
    return {
      productsForm: this.$inertia.form({
        _method: 'put',
        products: null,
      }),
      productForm: this.$inertia.form({
        _method: 'put',
        active: null,
      }),
      processing: false,
      expandedRows: []
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    updatePrice(e, product) {
        for (var i=0; i<this.products.length; i++) {
            if (this.products[i].id == product.id) {
                this.products[i].user_price = e.target.value;
            }
        }
    },
    updateInventory(e, product) {
        for (var i=0; i<this.products.length; i++) {
            if (this.products[i].id == product.id) {
                this.products[i].inventory_count = e.target.value;
            }
        }
    },
    save() {
        this.productsForm.products = JSON.stringify(this.products);
        this.productsForm.post(this.route('products.mtdupdate'))
    },

    deleteProduct(product) {
      this.$confirm.require({
          message: 'Are you sure?',
          header: 'Delete Product',
          icon: null,
          acceptLabel: 'Delete',
          rejectLabel: 'Cancel',
          accept: () => {
            this.$inertia.delete(this.route('mtd.products.destroy', product.id), { preserveScroll: true })
          },
          reject: () => {
              //callback to execute when user rejects the action
          }
      });
    },

    active(product) {
      this.productForm.active = product.active ? 1 : 0;
      this.productForm.post(this.route('mtd.products.active', product.id), { preserveScroll: true })
    }
  },
}
</script>

<style scoped>
  .my-products-img {
    min-height: 30px;
  }

  .store-price {
    max-width: 150px;
  }
</style>